import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import api from "../../../utils/api";
import axiosInstance from "../../../utils/axiosConfig";
import { RootState } from "../../rootReducer";

export const removeQuestionFromList = createAsyncThunk(
  "templateDetail/removeQuestionFromList",
  async ({ id, order }: { id: number; order: number }, { rejectWithValue, getState }) => {
    try {
      const state = getState() as RootState;
      const questionList = state.templateDetail.questionList;

      const nextQuestions = questionList.filter(({ order: orderInList }) => {
        if (orderInList && order) return orderInList > order;
      });

      for (const { order, id: questionId } of nextQuestions) {
        if (order && questionId) {
          await axiosInstance.patch(`${api.baseURL}formquestion/${questionId}`, {
            order: order - 1,
          });
        }
      }
      const { data } = await axiosInstance.delete(`${api.baseURL}formquestion/${id}`);

      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
